import moment from 'moment'

// 隐藏手机号中间4位
export function formatPhone(phone = '') {
  return phone.replace(/(\d{3})\d*(\d{4})/g, '$1***$2')
}

// 价格处理
export function formatPrice(price = '') {
  // 大于100000则不取小数
  if (price > 100000) {
    price = parseInt(price)
  }
  var y = String(price).indexOf('.') + 1 // 获取小数点的位置
  var count = String(price).length - y // 获取小数点后的个数
  if (count > 0) {
    return parseFloat(Number(price).toFixed(2))
  }
  return price
}

// 格式化时间
export function formatTime(data = '', format = 'YYYY-MM-DD') {
  if (data) {
    return moment(data).format(format)
  } else {
    return '--'
  }
}

// 微信昵称超出4个字符省略
export function stringModify(nickname = '', num = 4) {
  if (nickname.length > num) {
    nickname = nickname.substring(0, num) + '...'
  }
  return nickname
}

// 阅读数、点赞数处理
export function formatMaxNum(num = '') {
  num = Number(num)
  let max = 100000
  let min = 9999
  if (num > min && num <= max) {
    num = parseFloat(myFixed(num / 10000, 1)) + '万'
  } else if (num > max) {
    num = '10万+'
  }
  return num
}

function myFixed(num, digit) {
  if (Object.is(parseFloat(num), NaN)) {
    return console.log(`传入的值：${num}不是一个数字`)
  }
  num = parseFloat(num)
  return (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit)
}
